export type ProductOptimizerEvent =
  | 'form_optimizer_recommendation_impression'
  | 'form_optimizer_recommendation_applied'
  | 'form_optimizer_recommendation_dismissed'
  | 'form_optimizer_recommendation_undone';

interface GoogleAnalyticsEventConfig {
  eventName: 'form_optimizer_view' | 'form_optimizer_click' | 'form_optimizer_action_undone';
  eventLabel: string;
  eventType: 'view' | 'click';
}

export const OPTIMIZER_GA_EVENT_CONFIG: Record<ProductOptimizerEvent, GoogleAnalyticsEventConfig> = {
  form_optimizer_recommendation_impression: {
    eventName: 'form_optimizer_view',
    eventLabel: '弹窗_新建/编辑_查看优化建议小弹窗',
    eventType: 'view',
  },
  form_optimizer_recommendation_applied: {
    eventName: 'form_optimizer_click',
    eventLabel: '弹窗_新建/编辑_查看优化建议小弹窗_采用',
    eventType: 'click',
  },
  form_optimizer_recommendation_dismissed: {
    eventName: 'form_optimizer_action_undone',
    eventLabel: '弹窗_新建/编辑_查看优化建议小弹窗_取消',
    eventType: 'click',
  },
  form_optimizer_recommendation_undone: {
    eventName: 'form_optimizer_action_undone',
    eventLabel: '弹窗_新建/编辑_查看优化建议小弹窗_取消',
    eventType: 'click',
  },
};

export function resolveOptimizerPopId(pathname: string): string {
  const match = pathname.match(/\/wheel_of_fortune\/pop\/(?:copy\/)?([^/?#]+)/);
  return match ? decodeURIComponent(match[1]) : '';
}
